import React from 'react';
import { Icon } from './Icon.js';
export const IconCube2 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22.5V11", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M21.5 6.25001L22 6L12 11L2 6.00001L2.5 6.25001", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M22 18.0789V5.92105L12 1.5L2 5.92105V18.0789L12 22.5L22 18.0789Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconCube2.js.map